import script from "./PortfolioPageHero.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioPageHero.vue?vue&type=script&lang=ts&setup=true"

import "./PortfolioPageHero.vue?vue&type=style&index=0&id=d7f356a0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7f356a0"]])

export default __exports__